import {
  Box,
  Grid,
  Paper,
  Stack,
  Typography,
} from "@mui/material";

import AccountTreeIcon from "@mui/icons-material/AccountTree";
import GrassIcon from "@mui/icons-material/Grass";

function Taxonomy({ plant }) {
  if (!plant?.taxonomic_classification) return null;

  const taxonomy = plant.taxonomic_classification;

  return (
    <Paper
      elevation={0}
      sx={{
        mt: 5,
        p: {
          xs: 3,
          md: 4,
        },
        borderRadius: 5,
        background:
          "linear-gradient(135deg,#FFFFFF,#F8FBFC)",
        border: "1px solid #E4EDF2",
        boxShadow: "0 10px 30px rgba(11,60,93,.08)",
      }}
    >
      {/* Header */}

      <Stack
        direction="row"
        spacing={2}
        alignItems="center"
        mb={3}
      >
        <Box
          sx={{
            width: 55,
            height: 55,
            borderRadius: "50%",
            bgcolor: "#EEF5FA",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <AccountTreeIcon
            sx={{
              color: "#0B3C5D",
            }}
          />
        </Box>

        <Box>
          <Typography
            sx={{
              fontSize: {
                xs: "1.5rem",
                md: "2rem",
              },
              fontWeight: 700,
              color: "#0B3C5D",
            }}
          >
            Taxonomic Classification
          </Typography>

          <Typography
            color="text.secondary"
            fontSize={15}
          >
            Scientific classification of the plant species
          </Typography>
        </Box>
      </Stack>

      {/* Accent */}

      <Box
        sx={{
          width: 90,
          height: 4,
          bgcolor: "#43A047",
          borderRadius: 10,
          mb: 4,
        }}
      />

      {/* Taxonomy Cards */}

      <Grid container spacing={3}>
        {Object.entries(taxonomy).map(([key, value]) => (
          <Grid
            item
            xs={12}
            sm={6}
            md={4}
            lg={3}
            key={key}
          >
            <Paper
              elevation={0}
              sx={{
                p: 3,
                height: "100%",
                borderRadius: 4,

                background:
                  "linear-gradient(135deg,#FFFFFF,#F9FCFD)",

                border: "1px solid #E6EEF3",

                transition: ".35s",

                boxShadow:
                  "0 6px 18px rgba(11,60,93,.05)",

                "&:hover": {
                  transform: "translateY(-6px)",
                  boxShadow:
                    "0 15px 35px rgba(11,60,93,.12)",
                },
              }}
            >
              <Stack
                direction="row"
                spacing={1.5}
                alignItems="center"
                mb={2}
              >
                <Box
                  sx={{
                    width: 38,
                    height: 38,
                    borderRadius: "50%",
                    bgcolor: "#EEF5FA",

                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <GrassIcon
                    sx={{
                      color: "#43A047",
                      fontSize: 20,
                    }}
                  />
                </Box>

                <Typography
                  sx={{
                    fontWeight: 700,
                    color: "#0B3C5D",
                    fontSize: "1rem",
                  }}
                >
                  {key
                    .replace(/_/g, " ")
                    .replace(/\b\w/g, (c) =>
                      c.toUpperCase()
                    )}
                </Typography>
              </Stack>

              <Typography
                sx={{
                  color: "#555",
                  fontSize: "1rem",
                  lineHeight: 1.8,
                  wordBreak: "break-word",
                }}
              >
                {value}
              </Typography>
            </Paper>
          </Grid>
        ))}
      </Grid>

      {/* Footer */}

      <Box
        sx={{
          mt: 4,
          p: 3,
          borderRadius: 4,
          bgcolor: "#F5FAF7",
          borderLeft: "5px solid #43A047",

          display: "flex",
          gap: 2,
          alignItems: "flex-start",
        }}
      >
        <AccountTreeIcon
          sx={{
            color: "#2E7D32",
            mt: 0.3,
          }}
        />

        <Typography
          sx={{
            color: "#555",
            lineHeight: 1.9,
          }}
        >
          <strong style={{ color: "#0B3C5D" }}>
            Taxonomic Note:
          </strong>{" "}
          Taxonomic classification follows the accepted botanical hierarchy,
          providing the scientific placement of the species from Kingdom to
          Species. This classification supports plant identification,
          biodiversity documentation, herbarium studies, and botanical
          research.
        </Typography>
      </Box>
    </Paper>
  );
}

export default Taxonomy;